// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"15f25672","484":"c7f4c292","551":"9774cf7d","629":"156da228","869":"cf739fb5","974":"e0ba58bc"}[chunkId] + ".chunk.js";
};